import { createSlice } from "@reduxjs/toolkit";

import {
  updateBillingInfo,
  createCustomerCard,
  createCustomerSubscription,
  createDeal,
  updateDeal
} from "./actions";
import {
  createCustomer,
  updateCustomer,
  updateContact,
  getCustomerId,
  updateCustomerCard,

  getCountries,
  getStates,
  getCities
} from "../actions";

const initialState = {
  loadedFirstTime: false,
  loading: false,
  redirect: false,
  targetRedirect: "",
  subscriptionPlan: [],
  userRequested: false,
  userObtained: false,
  user: {},
  isNewUser: false,
  userHasCard: false,
  card: {},

  updateBillingData: false,
  updatedBillingData: false,
  createSubscription: false,
  subscription: {},
  invoice:{},
  subscriptionCreated: false,

  dealUpdated: false,

  redirect: false,
  target: "",

  countries: [],
  countriesRequested: false,
  countriesObtained: false,
  states: [],
  statesRequested: false,
  cities: [],
  citiesRequested: false
};

const paymentSlice = createSlice({
  name: "payment",
  initialState: initialState,
  reducers: {
    resetPayment: () => initialState,
    setSubscriptionPlan: (state, action) => {
      state.subscriptionPlan = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomerId.fulfilled, (state, action) => {
      state.loadedFirstTime = true;
      state.userObtained = true;
      state.user = action.payload.data.customer ? action.payload.data.customer : {};
      state.card = action.payload.data.card ? action.payload.data.card : {};
      state.userHasCard = action.payload.data.card !== undefined? true : false;
    })
    builder.addCase(getCustomerId.pending, (state, action) => {
      state.userRequested = true;
    })

    builder.addCase(createCustomer.fulfilled, (state, action) => {
      state.loadedFirstTime = true;
      state.userObtained = true;
      state.user = action.payload.success ? action.payload.data : {};
      state.userRequested = true;
      state.isNewUser = true;
    });
    builder.addCase(updateCustomer.fulfilled, (state, action) => {
      state.user = action.payload.success ? action.payload.data.customer : {};
    });

    builder.addCase(updateBillingInfo.fulfilled, (state, action)=>{
      state.updatedBillingData = action.payload.success ? true : false;
      state.createSubscription = action.payload.success ? true : false;
      state.user = action.payload.success ? action.payload.data : state.user;
    });
    builder.addCase(updateBillingInfo.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateBillingInfo.rejected, (state, action) => {
    });

    builder.addCase(createCustomerCard.fulfilled, (state, action) =>{
      state.loading = action.payload.success;
      state.updateBillingData = action.payload.success
    });
    builder.addCase(createCustomerCard.pending, (state, action) => {});

    builder.addCase(updateCustomerCard.fulfilled, (state, action) => {
      state.loading = action.payload.success;
    });
    builder.addCase(updateCustomerCard.pending, (state, action) => {});

    builder.addCase(createCustomerSubscription.fulfilled, (state, action) => {
      state.loading = action.payload.success ? true : false;
      state.user = action.payload.success ? action.payload.data.customer : state.user;
      state.subscription = action.payload.success ? action.payload.data.subscription : state.subscription;
      state.invoice = action.payload.success ? action.payload.data.invoice : state.invoice;
      state.subscriptionCreated = action.payload.success ? true : false;
    });
    builder.addCase(createCustomerSubscription.pending, (state, action) => {
      state.createSubscription = false;
    });
    builder.addCase(createCustomerSubscription.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(createDeal.fulfilled, (state, action) => {
      state.dealUpdated = true;
    });
    builder.addCase(createDeal.pending, (state)=>{});
    builder.addCase(createDeal.rejected, (state) => {
      state.loading = false;
      state.dealUpdated = true;
    });

    builder.addCase(updateDeal.fulfilled, (state, action) => {
      state.dealUpdated = true;
    });
    builder.addCase(updateDeal.rejected, (state, action) => {
      state.dealUpdated = true;
    });
    builder.addCase(updateDeal.pending, (state) => {});

    builder.addCase(updateContact.fulfilled, (state, action) => {
      state.redirect = true;
      state.target = "/invoice";
    })
    builder.addCase(updateContact.pending, (state, action) => {})

    builder.addCase(getCountries.pending, (state) => {
      state.countriesRequested = true
    })
    builder.addCase(getCountries.fulfilled, (state, action) => {
      state.loadedFirstTime = true;
      state.countriesObtained = action.payload.success ? true : false;
      state.countries = action.payload.success ? action.payload.data : [];
    })
    builder.addCase(getCountries.rejected, (state, action) => {
    })

    builder.addCase(getStates.pending, (state) => {
      state.statesRequested = true;
    })
    builder.addCase(getStates.fulfilled, (state, action) => {
      state.states = action.payload.success ? action.payload.data : [];
      state.statesRequested = false;
    })
    builder.addCase(getStates.rejected, (state) => {
      state.statesRequested = false;
    })

    builder.addCase(getCities.pending, (state) => {
      state.citiesRequested = true;
    })
    builder.addCase(getCities.fulfilled, (state, action) => {
      state.cities = action.payload.success ? action.payload.data : [];
      state.citiesRequested = false;
    })
    builder.addCase(getCities.rejected, (state, action) => {
      state.citiesRequested = false;
    })
  }
});

export const { setSubscriptionPlan, resetPayment } = paymentSlice.actions;
export default paymentSlice.reducer;